module.exports = __webpack_public_path__ + "media/images/MASTER-CARD-LOGO-87e200191f97c8d909f6f222ccb31888.png";